/** Convert time-domain audio to a bounded visual level. Remove DC offset before measuring RMS. */
export function getAudioLevel(samples: Float32Array): number {
  if (!samples.length) return 0
  let mean = 0
  for (let i = 0; i < samples.length; i++) mean += Number.isFinite(samples[i]) ? samples[i] : 0
  mean /= samples.length
  let energy = 0
  for (let i = 0; i < samples.length; i++) {
    const sample = samples[i]
    const centered = (Number.isFinite(sample) ? sample : 0) - mean
    energy += centered * centered
  }
  const rms = Math.sqrt(energy / samples.length)
  // Ignore room noise below roughly -50 dBFS; map speech logarithmically, not linearly.
  const db = 20 * Math.log10(Math.max(rms, 0.000001))
  return Math.max(0, Math.min(1, (db + 50) / 40))
}

/** Fast attack and slower release, independent of display refresh rate. */
export function smoothAudioLevel(previous: number, target: number, elapsedMs: number): number {
  const timeConstant = target > previous ? 45 : 140
  return previous + (target - previous) * (1 - Math.exp(-Math.max(0, elapsedMs) / timeConstant))
}
